// @flow

import * as React from "react";
import { type LinkType, type ImageType } from "../../types";
import Image from "../atoms/Image";

type PropsType = {
    imageDesktop?: ImageType,
    imageMobile?: ImageType,
    link?: LinkType,
    alt?: string,
    use_container?: boolean,
    colClass?: string,
    additionalClasses?: string,
    position?: string,
    pageType?: string,
};

const LeaderboardInner = (props: PropsType): React.Node => {
    return (
        <div className="leaderboard">
            <a
                href={props.link}
                title={props.alt}
                target="_blank"
                rel="noreferrer"
            >
                <Image
                    src={props.imageDesktop ? props.imageDesktop.url : ""}
                    alt={props.alt}
                    className="leaderboard__image leaderboard__image--desktop"
                />
                <Image
                    src={props.imageMobile ? props.imageMobile.url : ""}
                    alt={props.alt}
                    className="leaderboard__image leaderboard__image--mobile"
                />
            </a>
        </div>
    );
};

const Leaderboard = (props: PropsType): React.Node => {
    if (props.useContainer) {
        return (
            <div
                className={`container ${
                    props.additionalClasses || ""
                } leaderboard__container leaderboard__container--${
                    props.pageType || ""
                } leaderboard__container--${props.position || ""}`}
            >
                <div className="row">
                    <div className={props.colClass}>
                        <LeaderboardInner {...props} />
                    </div>
                </div>
            </div>
        );
    } else {
        return <LeaderboardInner {...props} />;
    }
};

Leaderboard.defaultProps = {
    colClass: "col-xs-12",
};
export default Leaderboard;
